var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTopBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 13,
    r: 1,
    fill: "#101828"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 1,
    fill: "#101828"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 1,
    fill: "#101828"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 1,
    fill: "#101828"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 1,
    fill: "#101828"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 1,
    r: 1,
    fill: "#101828"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4,
    r: 1,
    fill: "#101828"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 4,
    r: 1,
    fill: "#101828"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 7,
    r: 0.5,
    fill: "#101828"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 7,
    r: 0.5,
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopBlack);
export default __webpack_public_path__ + "static/media/arrow-top-black.bc5e2f3013b37bf4af0604fecca878e4.svg";
export { ForwardRef as ReactComponent };